import { Text } from "@mantine/core";
import classes from "../AdminDashboardView/AdminDashboardView.module.css";

const parseNumber = (s) => {
  const str = String(s ?? "").trim();
  if (!str || str === "-" || str === "—") return NaN;
  const cleaned = str.replace(/,/g, "").replace(/[₹\s]/g, "").replace(/%/g, "");
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
};

// Compact format for large numbers: 2.12M, 4.34L, 1.20Cr (no currency symbol)
const fmtCompactNumber = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return String(n ?? "");
  const sign = num < 0 ? "-" : "";
  const abs = Math.abs(num);
  if (abs >= 10000000) return `${sign}${(abs / 10000000).toFixed(2)}Cr`;
  if (abs >= 1000000) return `${sign}${(abs / 1000000).toFixed(2)}M`;
  if (abs >= 100000) return `${sign}${(abs / 100000).toFixed(2)}L`;
  if (abs >= 1000) return `${sign}${(abs / 1000).toFixed(2)}K`;
  return num.toLocaleString("en-IN");
};

const KpiCard = ({ label, value, tone = "blue", compact = false, detailsRows = [] }) => {
  const valueStr = value ?? "";
  const numericValue = typeof valueStr === "number" ? valueStr : parseNumber(valueStr);
  const isPercent = typeof valueStr === "string" && valueStr.includes("%");
  const shouldCompactValue = !isPercent && Number.isFinite(numericValue) && Math.abs(numericValue) >= 100000;
  const displayValue = shouldCompactValue ? fmtCompactNumber(numericValue) : valueStr;

  return (
    <div className={`${classes.card} ${classes.kpiCard}`}>
      <div className={`${classes.kpiStrip} ${classes[`tone${tone}`]}`} />
      <div className={classes.kpiBody}>
        <Text component="span" className={classes.kpiLabel}>{label}</Text>
        <Text
          className={compact ? classes.kpiValueCompact : classes.kpiValue}
          title={shouldCompactValue ? String(valueStr) : undefined}
        >
          {displayValue}
        </Text>
        {Array.isArray(detailsRows) && detailsRows.length ? (
          <div className={classes.kpiDetailsList}>
            {detailsRows.map((row) => (
              <div key={row.key} className={classes.kpiDetailsRow}>
                <span className={classes.kpiDetailsCurrency}>{row.currency}</span>
                {(() => {
                  const revNumeric = parseNumber(row.revenue);
                  const revShouldCompact = Number.isFinite(revNumeric) && Math.abs(revNumeric) >= 100000;
                  const revDisplay = revShouldCompact ? fmtCompactNumber(revNumeric) : row.revenue;
                  return (
                    <span className={classes.kpiDetailsRevenue} title={revShouldCompact ? String(row.revenue) : undefined}>
                      {revDisplay}
                    </span>
                  );
                })()}
                <span className={classes.kpiDetailsPct}>{row.percentage}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default KpiCard;